import { BaseService } from '@myhealth-raccoon/services';

import { authService } from '../auth';
import {
    PatientBasicDetails,
    PatientDetailsUpdateRequest,
    PatientHasDetails,
    PatientHealthInfo,
    UpdatePatientHealthInfoRequest,
} from './types';

class PatientService extends BaseService {
    constructor() {
        super('v1/site', import.meta.env.VITE_BP_API_URL);
    }

    get Authorization() {
        return authService.Authorization;
    }

    public async GetBasicDetails(siteId: string | number) {
        return this.get<PatientBasicDetails>(`${siteId}/bppatient/raccoonAuth/basic`);
    }

    public async GetPatientHealthInfo(siteId: string | number) {
        return this.get<PatientHealthInfo>(`${siteId}/bppatient/raccoonAuth/patient/healthInfo`);
    }

    public async UpdatePatientHealthInfo(siteId: string | number, update?: UpdatePatientHealthInfoRequest) {
        return this.put<PatientHealthInfo>(`${siteId}/bppatient/raccoonAuth/patient/healthInfo`, update);
    }

    public async PatientDetails(siteId: string | number) {
        return this.get<PatientHasDetails>(`${siteId}/bppatient/raccoonAuth/patient/details`);
    }

    public async UpdatePatientBasicDetails(siteId: string | number, update: PatientDetailsUpdateRequest) {
        return this.put(`${siteId}/bppatient/raccoonAuth/patient/details`, update);
    }
}

export const patientService = new PatientService();
export * from './types';
